import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getHistoryData = store => store[NAME].historyData;
export const getReasonsList = store => store[NAME].reasonsList;
